var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{staticClass:"digital"},[_c('div',{staticClass:"digital__top",attrs:{"slot":"header"},slot:"header"},[_c('h1',{staticClass:"digital__title"},[_vm._v("Добавление кейса")]),_c('SvMenu',{on:{"remove":_vm.remove,"copy":_vm.copy}})],1),_c('SvTabs',{staticClass:"digital__table",attrs:{"tabs":['Кейсы', 'SEO']},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}},[_c('div',{staticClass:"digital__actions"},[_c('SvButton',{staticClass:"residential-edit__action",attrs:{"view":"secondary","text":"Отмена","prependIcon":{
                    icon: 'cancel',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }},on:{"click":_vm.resetForm}}),_c('SvButton',{staticClass:"residential-edit__action",attrs:{"view":"secondary","text":"Применить","prependIcon":{
                    icon: 'refresh',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }},on:{"click":function($event){return _vm.save(false)}}}),_c('SvButton',{staticClass:"residential-edit__action",attrs:{"view":"primary","text":"Сохранить","prependIcon":{
                    icon: 'check',
                    width: 24,
                    height: 24,
                    default: '#1993EB',
                    hover: '#1993EB'
                }},on:{"click":function($event){return _vm.save(true)}}})],1)]),_c('keep-alive',[(_vm.current === 0)?_c('FormDigitalCases'):_vm._e(),(_vm.current === 1)?_c('FormDigitalSeo'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }